import ContainerSkeleton from "./ContainerSkeleton"

const ArticlesSkeleton = () => {
  return (
    <>
      {Array.from({ length: 4 }, (_, i) => (
        <div key={i} className="relative pb-[75px]">
          <ContainerSkeleton custH="h-[155px] sm:h-[170px] md:h-[175px] lg:h-[218px] 2xl:h-[320px]" custW="w-full" />
          <ContainerSkeleton custH="h-8" custCls="w-full mt-1 mb-2" />
          <div className="absolute bottom-0 left-1/2 -translate-x-1/2 w-full">
            <ContainerSkeleton custH="h-5" custCls="w-full mb-4" />
            <ContainerSkeleton custH="h-6" custW="w-full" />
          </div>
        </div>
      ))}
    </>
  )
}

const ArticlesRowSkeleton = () => {
  return (
    <div className="">
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6 lg:gap-8">
        <ArticlesSkeleton />
      </div>
    </div>
  )
}

export {
  ArticlesSkeleton,
  ArticlesRowSkeleton
}